import * as JsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

export default {
  props: ['idTabela', 'orientacao', 'tituloTabela','descricoes','entrada', 'retorno','resultados', 'nomeArquivo', 'nomeImagemParceiro'],
  created(){
  },

  data () {
    return {
      tamanhoLinha: 0,
      tamanhoTotal: 0
    }
  },
  methods: {
    configuraSubtitulo (opcoes) {
       opcoes.headerStyles={}
       opcoes.headerStyles.fillColor=[96,168,216] 
       opcoes.headerStyles.halign = "left"
       opcoes.startY-=5
    },

 
    gerarOpcoes (doc, espacamento, numeroPagina, linhas, titulo, primeiro) {

      let vm = this;
      let poweredText;
      let pageCounter;
      let titleMarginLeft;

       if (this.orientacao === 'p') {
        poweredText = 570;
        pageCounter = 400;
        titleMarginLeft = 250;
      } else {
        poweredText = 570;
        pageCounter = 660;
        titleMarginLeft = 400;
      }

      let header = function (data) {
        doc.setFontSize(16);
        doc.setTextColor(40);
        doc.setFontStyle('normal');
        doc.text(titleMarginLeft, 36, "");

        doc.setFontStyle('normal');
 
      };

      let footer = function(data) {
        doc.setFontSize(10);
        if (numeroPagina !== doc.internal.getNumberOfPages()) {
          vm.tamanhoLinha = 0
          espacamento = 0
          numeroPagina = doc.internal.getNumberOfPages()
          doc.text(40, poweredText, String(numeroPagina))
          doc.text(pageCounter, poweredText, 'Powered by Rancho Soluções');
        } 
      };

      let py = [];
      
      let options = {
        theme: 'striped',
        startY: primeiro ? 200 : doc.autoTableEndPosY() + 5,
        styles: {
          overflow: 'linebreak',
        },
        margin: {
          top: 30,
          bottom: 30
        },
        columnStyles:{
          0: {
            columnWidth: 260,
          },
          1: {
            columnWidth:130,
            halign: 'right',
            fontStyle: 'bold'
          },
          2: {
            columnWidth:260,
          },
          3: {
            columnWidth:130,
            halign: 'right',
            fontStyle: 'bold'                    
          }
         
        },
        drawHeaderRow (row, data) {
          py.push(row.y + 15)
        },
        drawRow (row, data) {
          vm.tamanhoLinha += row.height
          vm.tamanhoTotal += row.height
          if (vm.tamanhoLinha >= 560 ) {
            vm.tamanhoLinha = 0
            doc.addPage()
            espacamento = 0
          }
        },
        addPageContent: (data) => {
          header(data);
          footer(data);
          
          if (titulo) {
            let titulos = Array.isArray(titulo) ? titulo : [titulo]
            let posY = py.pop()
            for(var i = 0; i < titulos.length; i++) {
              let titulo = titulos[i]
              doc.setTextColor (255,255,255)
              doc.setFontSize (12)
              doc.setFontType ("bold")
              if (titulo.subtitulo) {
                doc.text(titulo.texto, 50, posY)
              } else {
                if (titulo.subtitulo1) {
                  doc.text(titulo.texto, 440, posY)
                } else {
                  doc.text(titulo, 425, posY, 'center')
                }  
              }
            }

          }
        },
        drawCell: (cell, data) => {
        
        }
      };

      espacamento = espacamento + (linhas.length + 2);
      return {
        opcoes: options,
        numeroPagina: numeroPagina,
        espacamento: espacamento
      };

    },
    shouldShow (value) {
      for (let i = 0; i < value.length; i++) {
        if (this.entrada.modalidadeDeSistemaDeProducaoEscolhida === value[i]) {
          return true
        }
      }
      return false
    },
    criarPDF () {

      let doc = new this.$JsPDF(this.orientacao, 'pt');

      this.entrada = this.$utils.exportaPdf.trataEntrada(this.entrada)

      let espacamento = 0;
      let numeroPagina = 0;
      let opcoes = {};
      let resp = {};
      this.tamanhoLinha = 0
      this.tamanhoTotal = 0

      this.$utils.exportaPdf.adicionaLogosConsolidado(doc, this.nomeImagemParceiro)

      doc.setFontSize (14)

      doc.setFontType ("bold")
      doc.centerText ('Relatório Consolidado (Confinamento - Simulação Avançado)', 40)

      let px = 280
      let px2 = 425
      doc.setFontSize (12)
      doc.setFontType ("normal")
      doc.text ('Nome da simulação:',px,80)

      doc.setFontType ("bold")
      doc.text (this.entrada.nome,px2,80)
      doc.setFontType ("normal")
      doc.text ("Data da simulação:",px,100)
      
      doc.setFontType ("bold")
      doc.text (this.retorno.criado_em,px2,100)
      doc.setFontType ("normal")
//      doc.text ("Tipo do projeto: ",px,120)
//      doc.setFontType ("bold")
//      doc.text ("Confinamento",px2,120)
      doc.setFontType ("normal")
      doc.text ("Modalidade de venda(s):",px,120)
      doc.setFontType ("bold")
      doc.text (this.entrada.modalidadeDaVendaEscolhida,px2,120)
      doc.setFontType ("normal")
      doc.text ("Estágio do negócio:",px,140)
      doc.setFontType ("bold")
      doc.text (this.entrada.estagioNegocio,px2,140)
      doc.setFontType ("normal")
      doc.text ("Sistema de produção:",px,160)
      doc.setFontType ("bold")
      doc.text (this.entrada.modalidadeDeSistemaDeProducaoEscolhida,px2,160)

      let naoAvaliado = "Não avaliado"

      let wpesoEntradaKgBalancaoDestino = naoAvaliado
      let wquebraDePesoOrigemBalancaoDestino = naoAvaliado
      let wpesoEntradaKgBalancinhaDestino = naoAvaliado
      let wpesoDeEntradaParaBoitelViaArrobaProduzidaOpcional = naoAvaliado   
      let wrendimentoDeEntradaBoitelViaArrobaProduzidaOpcional = naoAvaliado
      let wpesoDeEntradaEspecificoParaBoitelViaParceriaOpcional  = naoAvaliado
      let wrendimentoDeEntradaEspecificoBoitelViaParceriaOpcional  = naoAvaliado
      let wdespesaDeGTAFunruralGadoDeEngordaTerceirizadaCAB = naoAvaliado
      let wdespesaDeFreteCAB = naoAvaliado
      let wrentabilidadeOperacaoBoitel = naoAvaliado
      let wprecoDaArrobaProduzida = naoAvaliado
      let wgmdKgdBaseBalancinhaDestino = naoAvaliado
      let wganhoCarcacaKgdBaseBalancaoDestino = naoAvaliado
      let wganhoCarcacaKgdBaseBalancinhaDestino = naoAvaliado
      let wrendimentoGanhoBaseBalancaoDestino = naoAvaliado
      let wrendimentoGanhoBaseBalancinhaDestino = naoAvaliado
      let wgmdKgdBaseBalancaoDestino = naoAvaliado
      let wcustoToneladaMsTon = naoAvaliado
      let wquebraDePesoOrigemBalancinhaDestino = naoAvaliado
      


      if (this.shouldShow(['Boitel - kg de alimento consumido', 'Parceria', 'Boitel - diária', 'Boitel - @ produzida'])) {
        wquebraDePesoOrigemBalancaoDestino = this.entrada.quebraDePesoOrigemBalancaoDestino
        wdespesaDeGTAFunruralGadoDeEngordaTerceirizadaCAB = this.entrada.despesaDeGTAFunruralGadoDeEngordaTerceirizadaCAB
        wdespesaDeFreteCAB = this.entrada.despesaDeFreteCAB
        wrentabilidadeOperacaoBoitel = this.resultados.economicos.analiseEconomica.principal.rentabilidadeOperacaoBoitel
        wgmdKgdBaseBalancinhaDestino = this.resultados && this.resultados.produtivos ? this.resultados.produtivos.gmdKgdBaseBalancinhaDestino : ''
        wganhoCarcacaKgdBaseBalancaoDestino = this.resultados && this.resultados.produtivos ? this.resultados.produtivos.ganhoCarcacaKgdBaseBalancaoDestino : ''
        wganhoCarcacaKgdBaseBalancinhaDestino = this.resultados && this.resultados.produtivos ? this.resultados.produtivos.ganhoCarcacaKgdBaseBalancinhaDestino : ''
        wrendimentoGanhoBaseBalancaoDestino = this.resultados && this.resultados.produtivos ? this.resultados.produtivos.rendimentoGanhoBaseBalancaoDestino : ''
        wrendimentoGanhoBaseBalancinhaDestino = this.resultados && this.resultados.produtivos ? this.resultados.produtivos.rendimentoGanhoBaseBalancinhaDestino : ''
        wgmdKgdBaseBalancaoDestino = this.resultados && this.resultados.produtivos ? this.resultados.produtivos.gmdKgdBaseBalancaoDestino : ''
        wpesoEntradaKgBalancinhaDestino = this.resultados.produtivos.pesoEntradaKgBalancinhaDestino
        wpesoEntradaKgBalancaoDestino = this.resultados.produtivos.pesoEntradaKgBalancaoDestino
        wcustoToneladaMsTon = this.resultados.economicos.analiseEconomica.geral.custoToneladaMsTon
        wquebraDePesoOrigemBalancinhaDestino = this.entrada.quebraDePesoOrigemBalancinhaDestino
      }



      if (this.shouldShow(['Boitel - @ produzida'])) {
        wpesoDeEntradaParaBoitelViaArrobaProduzidaOpcional = this.entrada.pesoDeEntradaParaBoitelViaArrobaProduzidaOpcional
        wrendimentoDeEntradaBoitelViaArrobaProduzidaOpcional = this.entrada.rendimentoDeEntradaBoitelViaArrobaProduzidaOpcional
        wprecoDaArrobaProduzida = this.entrada.precoDaArrobaProduzida
      }

      if (this.shouldShow(['Parceria'])) {
        wrendimentoDeEntradaEspecificoBoitelViaParceriaOpcional = this.entrada.rendimentoDeEntradaEspecificoBoitelViaParceriaOpcional
        wpesoDeEntradaEspecificoParaBoitelViaParceriaOpcional = this.entrada.pesoDeEntradaEspecificoParaBoitelViaParceriaOpcional
      }

      let colunas = ['','       ','       ','       ']
      
      let linhas = [            

        [this.descricoes.items.racaDosAnimais.titulo,
          this.entrada.racaDosAnimais,
          this.descricoes.items.quebraDePesoOrigemBalancaoDestino.titulo,
          wquebraDePesoOrigemBalancaoDestino !== naoAvaliado ? wquebraDePesoOrigemBalancaoDestino + " %" : wquebraDePesoOrigemBalancaoDestino],

        [this.descricoes.items.sexoDosAnimais.titulo,
         this.entrada.sexoDosAnimais, 
         this.descricoes.items.quebraDePesoOrigemBalancinhaDestino.titulo,
         wquebraDePesoOrigemBalancinhaDestino !== naoAvaliado ? wquebraDePesoOrigemBalancinhaDestino + " %" : wquebraDePesoOrigemBalancinhaDestino],

        [this.descricoes.items.padraoRacialPredominante.titulo,
        this.entrada.padraoRacialPredominante, 
        this.descricoes.items.rendimentoDeCarcacaDaEntrada.titulo,
        this.entrada.rendimentoDeCarcacaDaEntrada + " %"], 

        [this.descricoes.items.totalAnimaisLote.titulo,
         this.entrada.totalAnimaisLote, 
         this.descricoes.items.rendimentoDeCarcacaDoAbate.titulo,
         this.entrada.rendimentoDeCarcacaDoAbate + " %"],

       [this.descricoes.items.pesoMedioEntradaKgCabBaseOrigem.titulo,
        this.entrada.pesoMedioEntradaKgCabBaseOrigem + " kg",
        this.descricoes.items.pesoDeEntradaParaBoitelViaArrobaProduzidaOpcional.titulo,
        wpesoDeEntradaParaBoitelViaArrobaProduzidaOpcional],
 
        [this.descricoes.items.quantidadeDiariasArracoamento.titulo,
        this.entrada.quantidadeDiariasArracoamento, 
        this.descricoes.items.rendimentoDeEntradaBoitelViaArrobaProduzidaOpcional.titulo,
        wrendimentoDeEntradaBoitelViaArrobaProduzidaOpcional],

        [this.descricoes.items.GMDKgD.titulo,
        this.entrada.gmdKgD + " kg/d", 
        this.descricoes.items.pesoDeEntradaEspecificoParaBoitelViaParceriaOpcional.titulo,
        wpesoDeEntradaEspecificoParaBoitelViaParceriaOpcional !== naoAvaliado ? wpesoDeEntradaEspecificoParaBoitelViaParceriaOpcional + " kg" : wpesoDeEntradaEspecificoParaBoitelViaParceriaOpcional],
       
       [this.descricoes.items.idadeDeEntradaMeses.titulo,
        this.entrada.idadeEntradaMeses, 
        "Rendimento de entrada, específico boitel via parceria (opcional)",
        wrendimentoDeEntradaEspecificoBoitelViaParceriaOpcional !== naoAvaliado ? wrendimentoDeEntradaEspecificoBoitelViaParceriaOpcional + " %" : wrendimentoDeEntradaEspecificoBoitelViaParceriaOpcional],
   

        [this.descricoes.items.mortalidadePercentual.titulo,
        this.entrada.mortalidadePercentual + " %", 
        this.descricoes.items.frigorificoDeAbate.titulo,
        this.entrada.frigorificoDeAbate],
    
        [this.descricoes.items.consumoMateriaSecaPercPV.titulo,
        this.entrada.consumoMateriaSecaPercPV + " % do PV",
        this.descricoes.items.estadoDeOrigem.titulo,
        this.entrada.estadoDeOrigem], 
        
        [this.descricoes.items.materiaSecaDietaPerc.titulo,
        this.entrada.materiaSecaDietaPerc + " %", 
        this.descricoes.items.cidadeDeOrigem.titulo,
        this.entrada.cidadeDeOrigem],

       [this.descricoes.items.nomeDaPropriedade.titulo,
        this.entrada.nomeDaPropriedade,
        "",
        ""], 

      ["","","",""]

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Informações Produtivas", true)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      let py=210

      doc.autoTable(colunas, linhas, opcoes) 
      doc.setTextColor(255,255,255)
      doc.setFontSize (12)
      doc.setFontType ("bold")
  

  colunas = ['','',
  '',
  ''],

  linhas = [
   
      [this.descricoes.items.valorDoGadoRCabeca.titulo,
       "R$ " + this.entrada.valorDoGadoRCabeca + " /cab",
       this.descricoes.items.despesaDeICMSCAB.titulo,
      "R$ " + this.entrada.despesaDeICMSCAB + " /cab"],

      [this.descricoes.items.precoReferenciaDoBoiGordo.titulo,
      "R$ " + this.entrada.precoReferenciaDoBoiGordo + " /@", 
      this.descricoes.items.despesaDeAbateAssessoriaOutrasDespesasCAB.titulo,
      "R$ " + this.entrada.despesaDeAbateAssessoriaOutrasDespesasCAB + " /cab"],


      [this.descricoes.items.taxaDeRemuneracaoDoCapitalDoGadoAm.titulo,
      this.entrada.taxaDeRemuneracaoDoCapitalDoGadoAm + " % am",
      this.descricoes.items.despesaDeGTADeAbateCAB.titulo,
      "R$ " + this.entrada.despesaDeGTADeAbateCAB + " /cab"],


      [this.descricoes.items.dataPagamentoDoGado.titulo,
      this.entrada.dataPagamentoGado, 
      this.descricoes.items.premioEU.titulo,
      "R$ " + this.entrada.premioEU + " /@" ], 

      [this.descricoes.items.dataD1Arracoamento.titulo,
      this.entrada.dataD1Arracoamento,
      this.descricoes.items.premioHilton.titulo,
      "R$ " + this.entrada.premioHilton + " /@"],


      [this.descricoes.items.diasEntreOEmbarqueEoAbate.titulo,
      this.entrada.diasEntreOEmbarqueEoAbate, 
      this.descricoes.items.premioAngus.titulo,
      "R$ " + this.entrada.premioAngus + " /@"], 

      
      [this.descricoes.items.diasEntreAbateRecebimento.titulo,
      this.entrada.diasEntreAbateRecebimento,
      this.descricoes.items.premioAcabamento.titulo,
      "R$ " + this.entrada.premioAcabamento + " /@"], 


      [this.descricoes.items.diasExtrasParaRecebimento.titulo,
      this.entrada.diasExtrasParaRecebimento, 
      this.descricoes.items.outrosPremios.titulo,
      "R$ " + this.entrada.outrosPremios + " /@"],


      [this.descricoes.items.custoOperacionalCabDia.titulo,
      "R$ " + this.entrada.custoOperacionalCabDia + " /cab/d",
      this.descricoes.items.deducoesAplicadasSobreROB.titulo,
      this.entrada.deducoesAplicadasSobreROB + " %"], 


      [this.descricoes.items.custoDeNutricaoDiarioMedioCABdia.titulo,
      "R$ " + this.entrada.custoDeNutricaoDiarioMedioCABdia + " /cab/d",
      this.descricoes.items.depreciacaoRcab.titulo,
      "R$ " + this.entrada.depreciacaoRcab + " /cab"], 


      [this.descricoes.items.custoDeProtocoloSanitarioSisbovCAB.titulo,
      "R$ " + this.entrada.custoDeProtocoloSanitarioSisbovCAB + " /cab",
      this.descricoes.items.amortizacaoRcab.titulo,
      "R$ " + this.entrada.amortizacaoRcab + " /cab"],

 
      [this.descricoes.items.custoDeMedicamentosOutrosCAB.titulo,
      "R$ " + this.entrada.custoDeMedicamentosOutrosCAB + " /cab",
      this.descricoes.items.naoOperacionalRcab.titulo,
      "R$ " + this.entrada.naoOperacionalRcab + " /cab"], 

     
      [this.descricoes.items.despesaDeGTAFunruralGadoDeEngordaTerceirizadaCAB.titulo,
      wdespesaDeGTAFunruralGadoDeEngordaTerceirizadaCAB !== naoAvaliado ? "R$ " + wdespesaDeGTAFunruralGadoDeEngordaTerceirizadaCAB + " /cab" :  wdespesaDeGTAFunruralGadoDeEngordaTerceirizadaCAB, 
      this.descricoes.items.impostoDeRendaRcab.titulo,
      "R$ " + this.entrada.impostoDeRendaRcab + " /cab"], 

      [this.descricoes.items.despesaDeFreteCAB.titulo,
      wdespesaDeFreteCAB !== naoAvaliado ? "R$ " + wdespesaDeFreteCAB + " /cab" :  wdespesaDeFreteCAB,
      this.descricoes.items.precoVendaBruto.titulo,
      "R$ " + this.entrada.precoVendaBruto + " /@"],
      

      [this.descricoes.items.despesaComissaoCompraCab.titulo,
      "R$ " + this.entrada.despesaComissaoCompraCab + " /cab",
      this.descricoes.items.precoDaArrobaProduzida.titulo,
      wprecoDaArrobaProduzida !== naoAvaliado ? "R$ " + wprecoDaArrobaProduzida + " /@" : wprecoDaArrobaProduzida],


      [this.descricoes.items.despesaDeComercializacaoCAB.titulo,
      "R$ " + this.entrada.despesaDeComercializacaoCAB + " /cab",
      this.descricoes.items.diferencialDeBase.titulo,
      "R$ " + this.entrada.diferencialDeBase + " /@"], 

      [" ",
       "", 
      this.descricoes.items.descontoAplicadoParaVendaVista.titulo,
      this.entrada.descontoAplicadoParaVendaVista + " %"]
     
    ]

    resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Informações Financeiras", false)
    opcoes = resp.opcoes;
    numeroPagina = resp.numeroPagina;
    espacamento = resp.espacamento;
   
    //doc.text(100,445,"Resultados Principais e Econômicos Principais")
     
    doc.autoTable(colunas, linhas, opcoes)  

   
      
    //============================================================================================== 
    // Resultados Principais  
    //==============================================================================================
      colunas = ['',
      '',
      '',
      '']

      linhas = [

      [this.descricoes.items.pesoSaidaKgBaseOrigem.titulo,
      this.resultados.produtivos.pesoSaidaKgBaseOrigem + " kg", 
      this.descricoes.items.rentabilidadeOperacao.titulo,
      this.resultados.economicos.analiseEconomica.principal.rentabilidadeOperacao + " %"],


      [this.descricoes.items.pesoSaidaArrobaBaseOrigem.titulo,
       this.resultados.produtivos.pesoSaidaArrobaBaseOrigem + " @",
       this.descricoes.items.lucroLiquido.titulo,
       "R$ " + this.resultados.economicos.dre.lucroLiquidoCab + " /cab"], 

       ["Data Abate",
       this.resultados.principais.dataAbate,
       this.descricoes.items.dataLiquidacaoFinanceira.titulo,
       this.resultados.economicos.analiseEconomica.geral.dataLiquidacaoFinanceira],
 
       [this.descricoes.items.custoArrobaEntradaMagra.titulo,
       "R$ " + this.resultados.economicos.analiseEconomica.custoProducao.custoArrobaEntradaMagra + " /@",
       this.descricoes.items.custoArrobaVendida.titulo,
       "R$ " + this.resultados.economicos.analiseEconomica.custoProducao.custoArrobaVendida + " /@"],

       [this.descricoes.items.custoArrobaProduzida.titulo,
       "R$ " + this.resultados.economicos.analiseEconomica.custoProducao.custoPorArrobaProduzida + " /@",
       this.descricoes.items.precoArrobaVendidaLivre.titulo,
       "R$ " + this.resultados.economicos.analiseEconomica.principal.precoArrobaVendidaLivre + " /@"]

  
       

      ]

       resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Resultados Principais")
       opcoes = resp.opcoes;
       numeroPagina = resp.numeroPagina;
       espacamento = resp.espacamento;
 
         
       doc.autoTable(colunas, linhas, opcoes)  
 
      
       py=50
       doc.setTextColor(255,0,255)
       doc.setFontSize (12)
       doc.setFontType ("bold")

     //*=====================================================================   
      //" Resultado Produtivo
      //*=====================================================================     
       
         colunas = ['',
         '',
         '',
         '']
         
       linhas = [
    
       ['Peso de entrada (base origem)',
       this.resultados.produtivos.pesoEntradaKgBaseOrigem + " kg",
       this.descricoes.items.gmdKgdBaseOrigem.titulo,
       this.resultados.produtivos.gmdKgdBaseOrigem + " kg/d"],
   
       ['Peso de entrada (base Balanção destino)',
       wpesoEntradaKgBalancaoDestino !== naoAvaliado ? wpesoEntradaKgBalancaoDestino + " kg" : wpesoEntradaKgBalancaoDestino,
       this.descricoes.items.gmdKgdBaseBalancaoDestino.titulo,
       wgmdKgdBaseBalancaoDestino !== naoAvaliado ? wgmdKgdBaseBalancaoDestino + " kg/d" : wgmdKgdBaseBalancaoDestino],
 
       ['Peso de entrada (base balancinha destino)',
       wpesoEntradaKgBalancinhaDestino !== naoAvaliado ? wpesoEntradaKgBalancinhaDestino + " kg" : wpesoEntradaKgBalancinhaDestino,
       this.descricoes.items.gmdKgdBaseBalancinhaDestino.titulo,
       wgmdKgdBaseBalancinhaDestino !== naoAvaliado ? wgmdKgdBaseBalancinhaDestino + " kg/d" : wgmdKgdBaseBalancinhaDestino],
            
       [this.descricoes.items.pesoEntradaArrobaBaseOrigem.titulo,
       this.resultados.produtivos.pesoEntradaArrobaBaseOrigem + " @",
       this.descricoes.items.ganhoCarcacaKgdBaseOrigem.titulo,
       this.resultados.produtivos.ganhoCarcacaKgdBaseOrigem + " kg/d"],

       [this.descricoes.items.pesoSaidaKgBaseOrigem.titulo,
        this.resultados.produtivos.pesoSaidaKgBaseOrigem + " kg",
        this.descricoes.items.ganhoCarcacaKgdBaseBalancaoDestino.titulo,
        wganhoCarcacaKgdBaseBalancaoDestino !== naoAvaliado ? wganhoCarcacaKgdBaseBalancaoDestino  + " kg/d" : wganhoCarcacaKgdBaseBalancaoDestino],
       
       [this.descricoes.items.pesoVivoColocadoKgBaseOrigem.titulo,
       this.resultados.produtivos.pesoVivoColocadoKgBaseOrigem + " kg",
       this.descricoes.items.ganhoCarcacaKgdBaseBalancinhaDestino.titulo,
       wganhoCarcacaKgdBaseBalancinhaDestino !== naoAvaliado ?  wganhoCarcacaKgdBaseBalancinhaDestino + " kg/d" : wganhoCarcacaKgdBaseBalancinhaDestino],

     
       [this.descricoes.items.pesoSaidaArrobaBaseOrigem.titulo,
       this.resultados.produtivos.pesoSaidaArrobaBaseOrigem + " @", 
       this.descricoes.items.rendimentoGanhoBaseOrigem.titulo,
       this.resultados.produtivos.rendimentoGanhoBaseOrigem + " %"],
    
       [this.descricoes.items.pesoSaidaKgCarcacaQuenteBaseOrigem.titulo,
       this.resultados.produtivos.pesoSaidaKgCarcacaQuenteBaseOrigem + " kg",
       this.descricoes.items.rendimentoGanhoBaseBalancaoDestino.titulo,
       wrendimentoGanhoBaseBalancaoDestino !== naoAvaliado ? wrendimentoGanhoBaseBalancaoDestino + " %" : wrendimentoGanhoBaseBalancaoDestino],
 
       [this.descricoes.items.quantidadeArrobaProduzidadaCabecaBaseOrigem.titulo,
       this.resultados.produtivos.quantidadeArrobaProduzidadaCabecaBaseOrigem,
       this.descricoes.items.rendimentoGanhoBaseBalancinhaDestino.titulo,
       wrendimentoGanhoBaseBalancinhaDestino !== naoAvaliado ? wrendimentoGanhoBaseBalancinhaDestino + " %" : wrendimentoGanhoBaseBalancinhaDestino],
               
       [this.descricoes.items.quantidadeArrobaProduzidadaLoteBaseOrigem.titulo,
       this.resultados.produtivos.quantidadeArrobaProduzidadaLoteBaseOrigem,
       this.descricoes.items.idadeAbateMeses.titulo,
       this.resultados.produtivos.idadeAbateMeses],

       [this.descricoes.items.quantidadeArrobaAbatidasLoteBaseOrigem.titulo,
       this.resultados.produtivos.quantidadeArrobaAbatidasLoteBaseOrigem,
       this.descricoes.items.diasParaGanhar1ArrobaBaseOrigem.titulo,
       this.resultados.produtivos.diasParaGanhar1ArrobaBaseOrigem],
     
       [this.descricoes.items.quantidadeContratosBmfProtecaoLote.titulo,
       this.resultados.produtivos.quantidadeContratosBmfProtecaoLote,
       this.descricoes.items.conversaoAlimentarKgMsKgPV.titulo,
       this.resultados.produtivos.conversaoAlimentarKgMsKgPV],

       [this.descricoes.items.d1Arracoamento.titulo,
       this.resultados.produtivos.d1Arracoamento,
       this.descricoes.items.eficienciaBiologicaKgMsArrobaProduziada.titulo,
       this.resultados.produtivos.eficienciaBiologicaKgMsArrobaProduziada], 
       
       [this.descricoes.items.dzArracoamento.titulo,
       this.resultados.produtivos.dzArracoamento,
       this.descricoes.items.eficienciaAlimentarKgPvKgMs.titulo,
       this.resultados.produtivos.eficienciaAlimentarKgPvKgMs],

       [this.descricoes.items.dataEmbarque.titulo,
        this.resultados.produtivos.dataEmbarque,
        this.descricoes.items.pesoVivoMedioDuranteArracoamentoKg.titulo,
        this.resultados.produtivos.pesoVivoMedioDuranteArracoamentoKg + " kg"], 

        ["Data Abate",
        this.resultados.produtivos.dataAbate,
        this.descricoes.items.consumoMedioMateriaSecaDiarioKgCab.titulo,
        this.resultados.produtivos.consumoMedioMateriaSecaDiarioKgCab],
      
        [this.descricoes.items.cicloProdutivoDias.titulo,
        this.resultados.produtivos.cicloProdutivoDias,
        this.descricoes.items.consumoMedioMateriaOriginalDiarioKgCab.titulo,
        this.resultados.produtivos.consumoMedioMateriaOriginalDiarioKgCab],

        [this.descricoes.items.cicloProdutivoMeses.titulo,
        this.resultados.produtivos.cicloProdutivoMeses,
        this.descricoes.items.mortesCabecas.titulo,
        this.resultados.produtivos.mortesCabecas],
    
  
        [this.descricoes.items.quantidadeArrobaGanhasCabecaMes.titulo,
          this.resultados.produtivos.quantidadeArrobaGanhasCabecaMes + " @",
          "" ,
          ""],

        ["","","",""],
        ["","","",""], 
        ["","","",""],  
        ["","","",""]    
   
     ]
        resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Resultados Produtivos")
        opcoes = resp.opcoes;
        numeroPagina = resp.numeroPagina;
        espacamento = resp.espacamento;

        doc.autoTable(colunas, linhas, opcoes)


      //*=====================================================================   
      //" "Resultados Econômicos"
      //*=====================================================================  

      colunas =  ['',
      '',
      '',
      '']
  
      linhas = [
      ]
      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Resultados Econômicos")
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;

      doc.autoTable(colunas, linhas, opcoes)
  
      //*=====================================================================   
      //" Análise econômica geral" 
      //*=====================================================================  

        colunas =  ['',
        '',
        '',
        '']
    
        linhas = [
      
                        
            [this.descricoes.items.agioArrobaEntrada.titulo,
            this.resultados.economicos.analiseEconomica.geral.agioArrobaEntrada + " %",
            this.descricoes.items.dataLiquidacaoFinanceira.titulo,
            this.resultados.economicos.analiseEconomica.geral.dataLiquidacaoFinanceira],
            
            [this.descricoes.items.cicloFinanceiroMeses.titulo,
            this.resultados.economicos.analiseEconomica.geral.cicloFinanceiroMeses,
            this.descricoes.items.custeioCab.titulo,
            "R$ "  + this.resultados.economicos.analiseEconomica.geral.custeioCab + " /cab"], 
    
            [this.descricoes.items.custoToneladaMsTon.titulo,
            wcustoToneladaMsTon !== naoAvaliado ? "R$ " + wcustoToneladaMsTon + " /ton" :  wcustoToneladaMsTon],
    
          ]
    
          let subtitulo = {texto: "Análise econômica geral", subtitulo: true} 
          resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)
          opcoes = resp.opcoes;
          numeroPagina = resp.numeroPagina;
          espacamento = resp.espacamento;
    
          this.configuraSubtitulo (opcoes)
    
          doc.autoTable(colunas, linhas, opcoes)
           
    
  
    //============================================================================================== 
    // Análise do custo de produção
    //==============================================================================================

    colunas =  ['',
    '',
    '',
    '']

    linhas = [    

      [this.descricoes.items.custoNutricaoPorArrobaProduzida.titulo,
      "R$ "  + this.resultados.economicos.analiseEconomica.custoProducao.custoNutricaoPorArrobaProduzida + " /@",
      this.descricoes.items.outrosCustosPorArrobaProduzidada.titulo,
      "R$ "  + this.resultados.economicos.analiseEconomica.custoProducao.outrosCustosPorArrobaProduzidada + " /@"],
      
      [this.descricoes.items.despesasPorArrobaProduzida.titulo,
      "R$ "  + this.resultados.economicos.analiseEconomica.custoProducao.despesasPorArrobaProduzida + " /@",
      this.descricoes.items.custoPorArrobaProduzida.titulo,
      "R$ "  + this.resultados.economicos.analiseEconomica.custoProducao.custoPorArrobaProduzida + " /@"],

      [this.descricoes.items.custoArrobaEntradaMagra.titulo,
      "R$ "  + this.resultados.economicos.analiseEconomica.custoProducao.custoArrobaEntradaMagra + " /@", 
      this.descricoes.items.custoArrobaVendida.titulo,
      "R$ "  + this.resultados.economicos.analiseEconomica.custoProducao.custoArrobaVendida + " /@"],
     
      [this.descricoes.items.custoAnimalVendidoComImposto.titulo,
      "R$ "  + this.resultados.economicos.analiseEconomica.custoProducao.custoAnimalVendidoComImposto + " /cab",
      "",""]
      

    ]

    subtitulo = {texto: "Análise do custo de produção", subtitulo: true}  
    resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)
    opcoes = resp.opcoes;
    numeroPagina = resp.numeroPagina;
    espacamento = resp.espacamento;

    this.configuraSubtitulo (opcoes)

    doc.autoTable(colunas, linhas, opcoes)


    //============================================================================================== 
    // Análise econômica principal
    //==============================================================================================

colunas =  ['',
    '',
    '',
    '']

    linhas = [    

       [this.descricoes.items.lucratividadeOperacao.titulo,
        this.resultados.economicos.analiseEconomica.principal.lucratividadeOperacao + " %",
        this.descricoes.items.rentabilidadeOperacao.titulo,
        this.resultados.economicos.analiseEconomica.principal.rentabilidadeOperacao + " %"],

        [this.descricoes.items.rentabilidadeOperacaoBoitel.titulo,
        wrentabilidadeOperacaoBoitel !== naoAvaliado ? wrentabilidadeOperacaoBoitel + " %" : wrentabilidadeOperacaoBoitel,
        this.descricoes.items.taxaMinimaAtratividadeIouTMA.titulo,
        this.resultados.economicos.analiseEconomica.principal.taxaMinimaAtratividadeIouTMA + " %"],

        [this.descricoes.items.margenEBITDA.titulo,
        this.resultados.economicos.analiseEconomica.principal.margenEBITDA + " %",
        this.descricoes.items.margemPorArrobaVendidaLivre.titulo,
        "R$ " + this.resultados.economicos.analiseEconomica.principal.margemPorArrobaVendidaLivre + " /@"],

        [this.descricoes.items.precoArrobaVendidaLivre.titulo,
        "R$ " + this.resultados.economicos.analiseEconomica.principal.precoArrobaVendidaLivre + " /@",
        this.descricoes.items.precoArrobaVendidaBruto.titulo,
        "R$ "  + this.resultados.economicos.analiseEconomica.principal.precoArrobaVendidaBruto + " /@"],
  
      ]

      subtitulo = {texto: "Análise econômica principal", subtitulo: true}  
      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)

      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;

      this.configuraSubtitulo (opcoes)

      doc.autoTable(colunas, linhas, opcoes)
    //============================================================================================== 
    // DRE do animal, sem considerar mortalidade
    //==============================================================================================
    colunas =  ['',
    '',
    '',
    '']

    linhas = [
       
        [this.descricoes.items.receitaOperacionalBrutaRobCab.titulo,
        "R$ " + this.resultados.economicos.dre.receitaOperacionalBrutaRobCab + " /cab", 
        this.descricoes.items.amortizacaoCab.titulo,
        "R$ " + this.resultados.economicos.dre.amortizacaoCab + " /cab"], 
   
        [this.descricoes.items.deducoesCab.titulo,
        "R$ " + this.resultados.economicos.dre.deducoesCab + " /cab",
        this.descricoes.items.ebitResultadoOperacionalCab.titulo,
        "R$ " + this.resultados.economicos.dre.ebitResultadoOperacionalCab + " /cab"], 
        
        [this.descricoes.items.receitaOperacionalLiquidaRolCab.titulo,
        "R$ " + this.resultados.economicos.dre.receitaOperacionalLiquidaRolCab + " /cab",
        this.descricoes.items.financeiroCab.titulo,
        "R$ " + this.resultados.economicos.dre.financeiroCab + " /cab"], 
     
        [this.descricoes.items.custoProdutoVendidoCpvCab.titulo,
        "R$ " + this.resultados.economicos.dre.custoProdutoVendidoCpvCab + " /cab", 
        this.descricoes.items.naoOperacionalCab.titulo,
        "R$ " + this.resultados.economicos.dre.naoOperacionalCab + " /cab"], 

        [this.descricoes.items.lucroBrutoCab.titulo,
        "R$ " + this.resultados.economicos.dre.lucroBrutoCab + " /cab", 
        this.descricoes.items.lucroAntesIrLairCab.titulo,
        "R$ " + this.resultados.economicos.dre.lucroAntesIrLairCab + " /cab"], 

        [this.descricoes.items.despesaTotalCab.titulo,
        "R$ " + this.resultados.economicos.dre.despesaTotalCab + " /cab", 
        this.descricoes.items.valorIrCab.titulo,
        "R$ " + this.resultados.economicos.dre.valorIrCab + " /cab"], 


        [this.descricoes.items.ebitdaResultadoOperacionalCab.titulo,
        "R$ " + this.resultados.economicos.dre.ebitdaResultadoOperacionalCab + " /cab", 
        this.descricoes.items.lucroLiquidoCab.titulo,
         "R$ " + this.resultados.economicos.dre.lucroLiquidoCab + " /cab"], 

         [this.descricoes.items.depreciacaoCab.titulo,
        "R$ " + this.resultados.economicos.dre.depreciacaoCab + " /cab"]

       

    


      ]
      subtitulo = {texto: "DRE do animal, sem considerar mortalidade", subtitulo: true}   
      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)

      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;

      this.configuraSubtitulo (opcoes)

      doc.autoTable(colunas, linhas, opcoes)
     
    
      //============================================================================================== 
      // Pontos de Equilibrio
      //==============================================================================================
      colunas =  ['',
      '',
      '',
      '']

      linhas = [
         
        [this.descricoes.items.pontoEquilibrioArrobaVendidaBruto.titulo,
        "R$ " + this.resultados.economicos.breakeven.precoVenda.pontoEquilibrioArrobaVendidaBruto + " /@",
        this.descricoes.items.pontoEquilibrioDiariaCabDia.titulo,
        "R$ " + this.resultados.economicos.analiseEconomica.custoProducao.pontoEquilibrioDiariaCabDia + " /cab/d"],
        
        [this.descricoes.items.valorVendaBoi.titulo,
        "R$ " + this.resultados.economicos.breakeven.boiMagro.valorVendaBoi + " /cab",
         this.descricoes.items.agioVendaArroba.titulo,
         this.resultados.economicos.breakeven.boiMagro.agioVendaArroba + " %"],
         
        [" ","",
        this.descricoes.items.valorVendaArroba.titulo,
        "R$ " + this.resultados.economicos.breakeven.boiMagro.valorVendaArroba],
        
                   
      ]

      subtitulo = {texto: "Pontos de Equilíbrio", subtitulo: true}   
      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)

      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;

      this.configuraSubtitulo (opcoes)

      doc.autoTable(colunas, linhas, opcoes)
      

  /*
      [this.descricoes.items.pontoEquilibrioDiariaCabDia.titulo,
        "R$ " + this.resultados.economicos.analiseEconomica.custoProducao.pontoEquilibrioDiariaCabDia + " /cab/dia",
      this.descricoes.items.precoArrobaVendidaLivre.titulo,
        "R$ "  + this.resultados.economicos.analiseEconomica.principal.precoArrobaVendidaLivre + " /@"], 

      [this.descricoes.items.precoArrobaVendidaBruto.titulo],
        "R$ "  + this.resultados.economicos.analiseEconomica.principal.precoArrobaVendidaBruto + " /@",
      "",""],
  
  */
      //============================================================================================== 
      // Análise de viabilidade do projeto, considerando as perdas com mortalidade
      //==============================================================================================
      colunas =  ['',
      '',
      '',
      '']

      linhas = [

      
      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas,"Análise de viabilidade do projeto, considerando as perdas com mortalidade" )
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;

      doc.autoTable(colunas, linhas, opcoes)

      if (this.shouldShow(['Confinamento próprio', 'Semiconfinamento ou Confinamento em pasto'])) {
          //============================================================================================== 
          // ÓTICA DO INVESTIDOR - sistemaArracoamentoProprio
          //==============================================================================================
          colunas =  ['',
          '',
          '',
          '']
    
          linhas = [
    
            [this.descricoes.items.capitalInvestido.titulo,
              "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.capitalInvestido,
              this.descricoes.items.valorFuturoAplicacaoGado.titulo,
              "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorFuturoAplicacaoGado],
        
              [this.descricoes.items.valorFuturoAplicacaoFinanceira.titulo,
              "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorFuturoAplicacaoFinanceira,
              this.descricoes.items.diferencaAplicacaoGadoFinanceira.titulo,
              "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.diferencaAplicacaoGadoFinanceira],
              
              [this.descricoes.items.lucroLiquidoTotalLoteSuplementado.titulo,
                "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalLoteSuplementado,
                this.descricoes.items.lucroLiquidoTotalAnimalSuplementado.titulo,
                "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalAnimalSuplementado],
    
              [this.descricoes.items.indiceLucratividade.titulo,
              this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.indiceLucratividade,
              this.descricoes.items.taxaInternaRetornoTir.titulo,
              this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.taxaInternaRetornoTir + " %"],
                  
              [this.descricoes.items.valorPresenteLiquidoVpl.titulo,
              "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.valorPresenteLiquidoVpl,
              this.descricoes.items.taxaMensalCapitalInvestidoGado.titulo,
              this.resultados.economicos.oticaInvestidor.sistemaArracoamentoProprio.taxaMensalCapitalInvestidoGado + " %"],
    
              
    
          
          ]
          let subtitulo = {texto: "Ótica do Investidor - Sistema Arraçoamento Próprio", subtitulo: true}
          resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo )
          opcoes = resp.opcoes;
          numeroPagina = resp.numeroPagina;
          espacamento = resp.espacamento;
    
          this.configuraSubtitulo (opcoes)
    
          doc.autoTable(colunas, linhas, opcoes)
      }

      if (this.shouldShow(['Boitel - kg de alimento consumido', 'Boitel - diária'])) {
        //============================================================================================== 
        // "Ótica do investidor (sistema de arraçoamento terceirizado - diárias ou alimento consumido"
        //==============================================================================================
        colunas =  ['',
        '',
        '',
        '']

        linhas = [

            
          [this.descricoes.items.capitalInvestido.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.capitalInvestido,
          this.descricoes.items.valorFuturoAplicacaoGado.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorFuturoAplicacaoGado],
        
          [this.descricoes.items.valorFuturoAplicacaoFinanceira.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorFuturoAplicacaoFinanceira,
          this.descricoes.items.diferencaAplicacaoGadoFinanceira.titulo, 
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.diferencaAplicacaoGadoFinanceira],

          [this.descricoes.items.lucroLiquidoTotalLoteSuplementado.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementado,
          this.descricoes.items.lucroLiquidoTotalAnimalSuplementado.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementado],

          [this.descricoes.items.indiceLucratividade.titulo,
          this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.indiceLucratividade,
          this.descricoes.items.taxaInternaRetornoTir.titulo,
          "% " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.taxaInternaRetornoTir],
              
          [this.descricoes.items.valorPresenteLiquidoVpl.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.valorPresenteLiquidoVpl,
          this.descricoes.items.taxaMensalCapitalInvestidoGado.titulo,
          this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.taxaMensalCapitalInvestidoGado + " %"],
        
        
        ]
        subtitulo = {texto: "Ótica do investidor (sistema de arraçoamento terceirizado - diárias ou alimento consumidor)", subtitulo: true}
        resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)
        opcoes = resp.opcoes;
        numeroPagina = resp.numeroPagina;
        espacamento = resp.espacamento;

        this.configuraSubtitulo (opcoes)

        doc.autoTable(colunas, linhas, opcoes)
      }

      if (this.shouldShow(['Boitel - @ produzida'])) {
        //============================================================================================== 
        // "Ótica do investidor - Arraçoamento Terceirizado - Modelo de Arroba Produzida"
        //==============================================================================================
        colunas =  ['',
        '',
        '',
        '']
  
        linhas = [
  
        [this.descricoes.items.capitalInvestido.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.capitalInvestido,
          this.descricoes.items.valorFuturoAplicacaoGado.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorFuturoAplicacaoGado],
          
          [this.descricoes.items.valorFuturoAplicacaoFinanceira.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorFuturoAplicacaoFinanceira,
          this.descricoes.items.diferencaAplicacaoGadoFinanceira.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.diferencaAplicacaoGadoFinanceira],
                
        [this.descricoes.items.lucroLiquidoTotalLoteSuplementado.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementado,
          this.descricoes.items.lucroLiquidoTotalAnimalSuplementado.titulo,
          "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalAnimalSuplementado],
  
          [this.descricoes.items.indiceLucratividade.titulo,
           this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.indiceLucratividade,
            this.descricoes.items.taxaInternaRetornoTir.titulo,
            "% " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.taxaInternaRetornoTir],
        
          [this.descricoes.items.valorPresenteLiquidoVpl.titulo,
            "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.valorPresenteLiquidoVpl,
            this.descricoes.items.taxaMensalCapitalInvestidoGado.titulo,
            this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.taxaMensalCapitalInvestidoGado + " %"],
          
          [this.descricoes.items.quantidadeArrobaProduzida.titulo,
            this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.quantidadeArrobaProduzida,
            this.descricoes.items.pontoEquilibrioArrobaVendidaBruto.titulo,
            "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.pontoEquilibrioArrobaProduzida]
       
        ]
      
        subtitulo = {texto: "Ótica do investidor - Arraçoamento Terceirizado - Modelo de Arroba Produzida", subtitulo: true}      
        resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)
        opcoes = resp.opcoes;
        numeroPagina = resp.numeroPagina;
        espacamento = resp.espacamento;
    
        this.configuraSubtitulo (opcoes)
    
        doc.autoTable(colunas, linhas, opcoes)
      }
      
      if (this.shouldShow(['Parceria'])) {
        //============================================================================================== 
        // "Ótica do investidor - Arraçoamento Terceirizado - Modelo de Arroba Parceria"
        //==============================================================================================
        colunas =  ['',
        '',
        '',
        '']
  
        linhas = [
  
          [this.descricoes.items.capitalInvestido.titulo,
            "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.capitalInvestido,
            this.descricoes.items.valorFuturoAplicacaoGado.titulo,
            "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorFuturoAplicacaoGado],
          
            [this.descricoes.items.valorFuturoAplicacaoFinanceira.titulo,
            "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorFuturoAplicacaoFinanceira,
            this.descricoes.items.diferencaAplicacaoGadoFinanceira.titulo,
            "R$ " +this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.diferencaAplicacaoGadoFinanceira],
      
            [this.descricoes.items.lucroLiquidoTotalLoteSuplementado.titulo,
              "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementado,
              this.descricoes.items.lucroLiquidoTotalAnimalSuplementado.titulo,
              "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementado],
  
            [this.descricoes.items.indiceLucratividade.titulo,
             this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.indiceLucratividade,
              this.descricoes.items.taxaInternaRetornoTir.titulo,
              "% " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.taxaInternaRetornoTir],
              
                [this.descricoes.items.valorPresenteLiquidoVpl.titulo,
                "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.valorPresenteLiquidoVpl,
                this.descricoes.items.taxaMensalCapitalInvestidoGado.titulo,
                this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.taxaMensalCapitalInvestidoGado + " %"],
              
                [this.descricoes.items.quantidadeArrobaProduzida.titulo,
                this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.quantidadeArrobaProduzida,
                this.descricoes.items.pontoEquilibrioArrobaProduzida.titulo,
                "R$ " + this.resultados.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.pontoEquilibrioArrobaProduzida]
            
          ]
        
        subtitulo = {texto: "Ótica do investidor - Arraçoamento Terceirizado - Modelo de Arroba Parceria", subtitulo: true}    
  
        resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)
        opcoes = resp.opcoes;
        numeroPagina = resp.numeroPagina;
        espacamento = resp.espacamento;
    
        this.configuraSubtitulo (opcoes)
    
        doc.autoTable(colunas, linhas, opcoes)
      }

      doc.save(this.nomeArquivo) 
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Completo/Confinamento/Exports/ExportarPDFeXLSController.js